import { AnchorCalculator, ShapeGeoBuilder } from '@jxUml';
import jxLogger from '../../../services/utils/jxLogger';

const _name = 'WaypointRightUpLine';

/**
 * Single-waypoint L-shape, HORIZONTAL-FIRST variant: fromShape exits RIGHT
 * (right border) to the waypoint, waypoint then goes UP to toShape
 * (entering toShape's BOTTOM border). Mirror of WaypointUpRightLine.js with
 * the two axes swapped — see WaypointStrategySelector.js for when this
 * (vs the vertical-first family) gets picked.
 * @param {object} connector
 * @param {object} fromShape
 * @param {object} toShape
 */
export function waypointRightUpLine(connector, fromShape, toShape) {
    const waypoints = connector.points || [];
    if (waypoints.length !== 1) return;
    const waypoint = waypoints[0];

    jxLogger(_name).logDebug(
        'run',
        `connector ${connector.id?.slice(0, 8)} | before | fromShape=${JSON.stringify({ x: fromShape.x, y: fromShape.y, w: fromShape.w, h: fromShape.h })} | toShape=${JSON.stringify({ x: toShape.x, y: toShape.y, w: toShape.w, h: toShape.h })} | waypoint=${JSON.stringify({ x: waypoint.x, y: waypoint.y })} | fromAnchor=${JSON.stringify(connector.fromAnchorPoint)} | toAnchor=${JSON.stringify(connector.toAnchorPoint)}`,
    );

    const fromEffectiveH = ShapeGeoBuilder.effectiveHeight(fromShape);
    const toEffectiveH = ShapeGeoBuilder.effectiveHeight(toShape);

    // Segment 1 (horizontal): fromShape exits its RIGHT border, shares fromAnchor's world Y.
    // A manual anchor is clamped to the shape's current bounds rather than
    // reset to center when out of range (e.g. after a collapse) — keeps
    // anchors spread along the border instead of collapsing onto one point.
    const sharedY1 = connector.fromAnchorPoint
        ? AnchorCalculator.toShape(fromShape, connector.fromAnchorPoint).y
        : fromShape.y + fromEffectiveH / 2;
    connector.fromAnchorPoint = { x: fromShape.w, y: AnchorCalculator.clamp(sharedY1 - fromShape.y, 0, fromEffectiveH) };
    waypoint.y = sharedY1;

    // Segment 2 (vertical): toShape entered via its BOTTOM border, shares toAnchor's world X.
    const sharedX2 = connector.toAnchorPoint
        ? AnchorCalculator.toShape(toShape, connector.toAnchorPoint).x
        : toShape.x + toShape.w / 2;
    connector.toAnchorPoint = { x: AnchorCalculator.clamp(sharedX2 - toShape.x, 0, toShape.w), y: toEffectiveH };
    waypoint.x = sharedX2;

    jxLogger(_name).logDebug(
        'run',
        `connector ${connector.id?.slice(0, 8)} | after | waypoint=${JSON.stringify({ x: waypoint.x, y: waypoint.y })} | fromAnchor=${JSON.stringify(connector.fromAnchorPoint)} | toAnchor=${JSON.stringify(connector.toAnchorPoint)}`,
    );
}
